import Vue from "vue";

Vue.directive('numbers-only', function (el, binding, vnode) {
    const handler = function (e) {
        const valueInput = e.target.value;
        let regex = /[^0-9]/g;
        if (regex.test(valueInput)) {
            e.target.value = valueInput.replace(/[^0-9]/g, '');
            vnode.elm.dispatchEvent(new CustomEvent('input'));
        }
    };
    el.addEventListener('input', handler)
});
